import { h as handleKeyDownEvents } from './utils-CQt-4mmE.js';

function usePopoverSelectListHelper({
  anchorEl,
  onClose,
  focusAnchorElDisabled
}) {
  const handleFocus = element => {
    if (element) {
      element.focus();
    }
  };
  const handleEscape = () => {
    onClose === null || onClose === void 0 || onClose();
    if (!focusAnchorElDisabled) {
      handleFocus(anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.current);
    }
  };
  const handleKeyDown = event => {
    handleKeyDownEvents(event, handleEscape);
  };
  return {
    handleEscape,
    handleKeyDown
  };
}

export { usePopoverSelectListHelper as u };
//# sourceMappingURL=usePopoverSelectListHelper-rZOiKEI0.js.map
